enum ProjectFilterName {
  Forecast = 'Forecast',
  Actuals = 'Actuals',
  Difference = 'Difference',
  Discounts = 'Discounts'
}

export default ProjectFilterName;
